module.exports = __webpack_public_path__ + "media/bootstrap-icons/union-a736a4fe.svg";